import styled from 'styled-components/native';

import { getScaledValue } from '../../ui/styled';

import { withFocusable } from '@noriginmedia/react-spatial-navigation';

export const Container = styled.View.attrs({})`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: #000000;
  padding: ${getScaledValue(60)}px ${getScaledValue(80)}px;
`;

export const Title = styled.Text.attrs({})`
  fontfamily: Inter-Bold;
  color: #ffffff;
  fontsize: ${getScaledValue(20)}px;
  margin-bottom: ${getScaledValue(6)}px;
`;

export const HistoryList = styled.ScrollView.attrs({})`
  flex: 1;
`;

export const ReleaseCard = styled.View.attrs({})<{ $latest: boolean }>`
  padding: ${getScaledValue(14)}px;
  margin-bottom: ${getScaledValue(14)}px;
  border-radius: ${getScaledValue(6)}px;
  border-width: ${(props: { $latest: boolean }) => (props.$latest ? getScaledValue(1) : 0)}px;
  border-color: ${(props: { theme: { primary: string } }) => props.theme.primary};
  background-color: #111111;
`;

export const ReleaseHeader = styled.View.attrs({})`
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

export const VersionText = styled.Text.attrs({})`
  fontfamily: Inter-Light;
  color: ${(props: { theme: { primary: string } }) => props.theme.primary};
  fontsize: ${getScaledValue(11)}px;
  margin-bottom: ${getScaledValue(2)}px;
`;

export const LatestBadge = styled.View.attrs({})`
  border-radius: ${getScaledValue(8)}px;
  padding: ${getScaledValue(2)}px ${getScaledValue(6)}px;
  background-color: ${(props: { theme: { primary: string } }) => props.theme.primary};
`;

export const LatestBadgeText = styled.Text.attrs({})`
  fontfamily: Inter-Bold;
  color: #000000;
  fontsize: ${getScaledValue(7)}px;
`;

export const DateText = styled.Text.attrs({})`
  fontfamily: Inter-Light;
  color: #b9b9b9;
  fontsize: ${getScaledValue(8)}px;
  margin-bottom: ${getScaledValue(12)}px;
`;

export const BulletRow = styled.View.attrs({})`
  flex-direction: row;
  margin-bottom: ${getScaledValue(10)}px;
`;

export const BulletDot = styled.Text.attrs({})`
  color: ${(props: { theme: { primary: string } }) => props.theme.primary};
  fontsize: ${getScaledValue(9)}px;
  margin-right: ${getScaledValue(6)}px;
`;

export const BulletText = styled.Text.attrs({})`
  flex: 1;
  fontfamily: Inter-Light;
  color: #ffffff;
  fontsize: ${getScaledValue(9)}px;
`;

export const BackButton = withFocusable({})(styled.TouchableOpacity.attrs({})`
  flex-direction: row;
  align-items: center;
  justify-content: center;
  margintop: ${getScaledValue(30)}px;
  borderradius: ${getScaledValue(6)}px;
  height: ${getScaledValue(27)}px;
  min-width: ${getScaledValue(100)}px;
  cursor: pointer;
  ${(props: { focused?: boolean; theme: { primary: string } }) =>
    props.focused
      ? `
            background: ${props.theme.primary};
        `
      : `
            background: transparent;
            border: 1px solid ${props.theme.primary};
        `}
`);

export const BackButtonText = styled.Text.attrs({})`
  text-transform: uppercase;
  fontfamily: Inter-Light;
  color: #ffffff;
  fontsize: ${getScaledValue(8)}px;
`;
